export default __webpack_public_path__ + "static/media/mint-page-gif-mobile.0e31832b.gif";